import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconSortAscStyle0 = gravityIconIndividualCss;

const GravityIconSortAsc = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '9a19c29e19a15484806cade4df7069d0eb60efaf', color: this.color, size: this.size }, h("svg", { key: '16e5d67c05891d0aca956bbac9d3f4582faa51da', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '6d84c2c52a4837ff907acd13494f17532f5222ee', d: "M11.75 7.874h2.284a.4.4 0 0 0 .283-.683l-3.034-3.034a.4.4 0 0 0-.566 0L7.683 7.191a.4.4 0 0 0 .283.683h2.284v9.5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-9.5Z", fill: "currentColor" }))));
    }
};
GravityIconSortAsc.style = GravityIconSortAscStyle0;

export { GravityIconSortAsc as gravity_icon_sort_asc };

//# sourceMappingURL=gravity-icon-sort-asc.entry.js.map